export class DateFormatterModel {
  constructor(public target = '', public source = '', public format = '', public timezone = 'UTC') {}
}
